module.exports = __webpack_public_path__ + "static/media/NurseF1.3d2922dd.jpg";